<template src="./AssignDocumentPlan.html"></template>

<script>
import {
  getCompany,
  getAllTemplatesDocumentPlan,
  assignDocumentPlanCompany,
} from "../../../services";
import DocumentList from "../../../components/Forms/DocumentList/DocumentList";

export default {
  name: "AssignDocumentPlan",
  components: {
    DocumentList,
  },
  data() {
    return {
      company: {},
      documentPlan: null,
      assignedUser: null,
      plans: [],
      documents: [],
      documentPlanId: null,
      showDocumentForm: false,
      showDocumentSection: false,
      newDocument: {
        name: "",
        plannedDate: new Date().toISOString().substr(0, 10),
      },
      menu: false,
      editingPlan: false,
    };
  },

  computed: {
    isPlanAssigned() {
      return !!this.company.idDocumentPlan;
    },
  },

  created() {
    this.getCompanyInfo();
    this.getDocumentsPlans();
  },

  methods: {
    async getCompanyInfo() {
      try {
        this.company = await getCompany(this.$route.params.id);
        if (this.company.idDocumentPlan) {
          this.documentPlan = this.company.idDocumentPlan;
          this.documentPlanId = this.company.idDocumentPlan.id;
          this.editingPlan = false;
          this.showDocumentSection = false;
        } else {
          this.editingPlan = true;
          this.documents = [];
          this.documentPlan = null;
          this.showDocumentSection = false;
        }

        if (this.company.userCompliance) {
          this.assignedUser = this.company.userCompliance;
        } else {
          this.assignedUser = null;
        }
      } catch (err) {
        console.log("Error on get company:", err);
      }
    },
    async getDocumentsPlans() {
      try {
        const info = await getAllTemplatesDocumentPlan();
        this.plans = info;
      } catch (err) {
        console.log("Error on get templates plans:", err);
      }
    },
    async assignPlan() {
      try {
        if (!this.assignedUser) {
          this.$swal({
            text: "Debe asignar un usuario",
            buttons: false,
            icon: "warning",
            timer: 3000,
          });
          return;
        }
        if (!this.documentPlanId) {
          this.$swal({
            text: "Debe seleccionar un plan documental",
            buttons: false,
            icon: "warning",
            timer: 3000,
          });
          return;
        }
        if (this.documents.length === 0) {
          this.$swal({
            text: "Debe añadir al menos un documento al plan.",
            buttons: false,
            icon: "warning",
            timer: 3000,
          });
          return;
        }

        const payload = {
          companyId: this.$route.params.id,
          documentPlanId: this.documentPlanId,
          userId: this.assignedUser.id,
          documents: this.documents.map((document) => ({
            name: document.name,
            plannedDate: new Date(document.plannedDate).toISOString(),
          })),
        };
        await assignDocumentPlanCompany(payload);
        await this.getCompanyInfo();
        this.editingPlan = false;
        this.showDocumentForm = false;
        this.showDocumentSection = false;

        this.$swal({
          text: "Plan asignado correctamente.",
          buttons: false,
          icon: "success",
          timer: 3000,
        });
      } catch (error) {
        console.log("Error on assign Plan:", error);
        this.$swal({
          text: error.message || "Ocurrio un error, intenta mas tarde.",
          buttons: false,
          icon: "error",
          timer: 3000,
        });
      }
    },
    updateDocuments(plan) {
      this.documents = plan && plan.documents ? plan.documents : [];
      this.documentPlanId = plan ? plan.id : null;
      this.showDocumentSection =
        (this.documents.length > 0 || this.showDocumentForm) && !!plan;
    },
    showFormDocument() {
      this.showDocumentForm = true;
    },
    removeDocument(document) {
      this.documents = this.documents.filter((t) => t !== document);
      if (this.documents.length === 0 && !this.showDocumentForm) {
        this.showDocumentSection = false;
      }
    },
    addDocument() {
      if (this.newDocument.name) {
        this.documents.push({
          ...this.newDocument,
        });
        this.newDocument.name = "";
        this.newDocument.plannedDate = new Date().toISOString().substr(0, 10);
        this.showDocumentForm = false;
        this.showDocumentSection = this.documents.length > 0;
      } else {
        this.$swal({
          text: "El nombre es obligatorio",
          buttons: false,
          icon: "warning",
          timer: 3000,
        });
      }
    },
    cancelDocument() {
      this.newDocument.name = "";
      this.newDocument.plannedDate = new Date().toISOString().substr(0, 10);
      this.showDocumentForm = false;
      if (this.documents.length === 0) {
        this.showDocumentSection = false;
      }
    },
    togglePlanAssignment() {
      this.editingPlan = true;
      this.showDocumentSection = false;
      this.documents = [];
      this.documentPlan = null;
      this.showDocumentForm = false;
    },
  },
  watch: {
    documentPlan(newPlan) {
      this.updateDocuments(newPlan);
      if (!newPlan) {
        this.showDocumentSection = false;
        this.documents = [];
      }
    },
  },
};
</script>

<style lang="scss" src="./AssignDocumentPlan.scss" scoped></style>
